module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a7-2-72c22410953293493fef9bef73e52268.jpg";